// extracted by mini-css-extract-plugin
export default {"div":"Checkbox_div__QCWrE"};